// paymentContext.js
import { createContext } from 'react';

export const PaymentContext = createContext();
